<template>
  <!-- Ícone monocromático reutilizável: usa um SVG (preto) como máscara e pinta
       com qualquer cor via background. Reaproveita 1 arquivo para qualquer cor.
       Uso: <MaskIcon :src="require('.../icone.svg')" color="#fff" :size="20" /> -->
  <span class="mask-icon" :style="style"></span>
</template>

<script>
export default {
  name: "MaskIcon",
  props: {
    src: { type: String, required: true },     // URL do SVG (require(...))
    color: { type: String, default: "#000000" }, // qualquer cor
    size: { type: [Number, String], default: 20 },
  },
  computed: {
    style() {
      const s = typeof this.size === "number" ? this.size + "px" : this.size;
      const url = "url('" + this.src + "')";
      return {
        width: s,
        height: s,
        backgroundColor: this.color,
        "-webkit-mask": url + " center / contain no-repeat",
        mask: url + " center / contain no-repeat",
      };
    },
  },
};
</script>

<style scoped>
.mask-icon {
  display: inline-block;
  flex: 0 0 auto;
}
</style>
